import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { chatDirectoryApi, type MuteDuration } from '@/api/chatDirectory'

export function useChatPeople() {
  return useQuery({
    queryKey: ['chat-people'],
    queryFn: chatDirectoryApi.people,
    staleTime: 60_000,
  })
}

export function useChatOrganizations() {
  return useQuery({
    queryKey: ['chat-orgs'],
    queryFn: chatDirectoryApi.organizations,
    staleTime: 60_000,
  })
}

export function useHumanConversations() {
  return useQuery({
    queryKey: ['chat-human-conversations'],
    queryFn: chatDirectoryApi.humanConversations,
    staleTime: 30_000,
  })
}

export function useOpenDm() {
  return useMutation({
    mutationFn: (userId: number) => chatDirectoryApi.openDm(userId),
  })
}

export function useOpenOrg() {
  return useMutation({
    mutationFn: (orgId: number) => chatDirectoryApi.openOrg(orgId),
  })
}

export function useToggleMute(cid: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (vars: { muted: boolean; duration?: MuteDuration }) =>
      chatDirectoryApi.toggleMute(cid, vars.muted, vars.duration),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chat-human-conversations'] })
    },
  })
}
